import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccSettingHeader from "./acc_setting_header";
import HeaderMenu from "../sidebar/headermenu";
import { API_STATUS } from "../../constants";
import { GetContactRequest } from "../../apis/notification/get_contact_request";
import GetDate from "../../utils/getdate";
import { ApproveContactRequest } from "../../apis/notification/approve_contact_request";
// import { ApproveContactRequest } from "../../apis/notification/approve_contact_request"; // Import your API helper

export default function ContactRequests() {
    const navigate = useNavigate();
    const [loginId, setLoginId] = useState("");
    const [loginType, setLoginType] = useState("");
    const [userData, setUserData] = useState("");
    const [getApi, setGetApi] = useState(API_STATUS);
    const [approveApi, setApproveApi] = useState(API_STATUS);
    const [noResult, setNoResult] = useState(false);
    const [result, setResult] = useState([]);
    
    // Tracks cr_id currently processing approval
    const [actionId, setActionId] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);

            const utype = sessionStorage.getItem('USER_TYPE');
            setLoginType(utype);
        }
        GetContactRequest(setGetApi);
    }, []);

    useEffect(() => {
        const loginData = sessionStorage.getItem('LOGIN_DATA');
        if (loginData !== null) {
            const uData = JSON.parse(loginData);
            setUserData(uData);
        }
    }, []);

    useEffect(() => {
        if (!getApi.isLoader && !getApi.isError && getApi.data != null) {
            const res = getApi.data;
            if (res['status'] == 1) {
                setResult(res['data']);
                setNoResult(false);
            } else {
                setNoResult(true);
            }
        }
    }, [getApi]);

    // Handle Approve Click
    const handleApprove = (crId) => {
        setActionId(crId);
        const body = { request_id: crId };
        
        // Pass body and API state setter to your API function
         ApproveContactRequest(body, setApproveApi);
    };

    // Listen for Approval API state completion
    useEffect(() => {
        if (!approveApi.isLoader && !approveApi.isError && approveApi.data != null) {
            if (approveApi.data['status'] == 1 && actionId) {
                // Update local status or remove approved item from state
                setResult((prev) =>
                    prev.map((item) =>
                        item.cr_id === actionId ? { ...item, status: "1" } : item
                    )
                );
                
            }
            setActionId(null);
            GetContactRequest(setGetApi);
        }
    }, [approveApi]);

    return (
        <div id="wrapper">
            <HeaderMenu />
            <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
                {userData !== "" && (
                    <div className="max-w-2xl mx-auto px-1 py-1">
                        <div className="page__heading py-6 mt-6">
                            <a href={'/profile/' + loginId}>
                                <ion-icon name="chevron-back-outline"></ion-icon> Back
                            </a>
                            <h1>Account Settings</h1>
                        </div>

                        <AccSettingHeader userData={userData} activeTab={'contact_request'} />

                        <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80">
                            <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-8 md:px-12 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                                <div className="uk-active" style={{ position: 'relative' }}>
                                    
                                    <h2 className="text-base font-semibold text-black dark:text-white mb-4">
                                        Contact Access Requests
                                    </h2>

                                    {/* Loading State */}
                                    {getApi.isLoader && (
                                        <div className="text-center py-6">Loading requests...</div>
                                    )}

                                    {/* Empty State */}
                                    {!getApi.isLoader && (noResult || result.length === 0) && (
                                        <div className="text-center py-8 text-gray-500">
                                            No pending contact requests found.
                                        </div>
                                    )}

                                    {/* Requests List */}
                                    {!getApi.isLoader && result.length > 0 && (
                                        <div className="divide-y divide-gray-100 dark:divide-slate-700">
                                            {result.map((item) => (
                                                <div key={item.cr_id} className="py-4 flex items-center justify-between gap-4">
                                                    <div>
                                                        <p className="text-sm font-semibold text-black dark:text-white">
                                                            <a href={"/profile/"+item.from_user}>{item.u_fname} {item.u_lname}</a>
                                                        </p>
                                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                            Requested to view  your{' '}
                                                            <span className="font-semibold text-blue-600 capitalize">
                                                                {item.request_for}
                                                            </span>
                                                        </p>
                                                        <span className="text-[11px] text-gray-400 block mt-1">
                                                            {GetDate(item.created)}
                                                        </span>
                                                    </div>

                                                    <div>
                                                        {item.status == "1" ? (
                                                            <span className="text-xs bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 px-3 py-1 rounded-full font-medium">
                                                                Approved
                                                            </span>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                disabled={actionId === item.cr_id}
                                                                onClick={() => handleApprove(item.cr_id)}
                                                                className="inline-flex items-center gap-1.5 text-xs bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition"
                                                            >
                                                                {actionId === item.cr_id ? (
                                                                    <>
                                                                        <svg className="animate-spin h-3.5 w-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                        </svg>
                                                                        <span>Approving...</span>
                                                                    </>
                                                                ) : (
                                                                    "Approve"
                                                                )}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}